import type { CodeCopyLabels } from './CodeBlock.js';

/** Code-block copy words for the Turkish-UI surfaces (AI chat/page, QA overlay, roadmap). */
export const AI_CODE_COPY_LABELS: CodeCopyLabels = { copy: 'Kopyala', copied: 'Kopyalandı' };
